module.exports = __webpack_public_path__ + "img/nets.f93cdeff.svg";